
import XHeader from 'vux/src/components/x-header/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import { request } from "../utils/axios";
import AppointmentRecord from "./appointment-record.vue";
import axios from "axios";
export default {
components: {
XHeader,
Card,
Tabbar,
TabbarItem,
Scroller,
AppointmentRecord,
Toast,
},
data() {
return {
size: 10,
page: 1,
showMenus: 1, // 初始显示第一个视图
contentData: [], // 用于存储列表数据
pulldownConfig: {
content: "下拉刷新",
height: 40,
autoRefresh: false,
downContent: "下拉刷新",
upContent: "释放后刷新",
loadingContent: "正在刷新...",
clsPrefix: "xs-plugin-pulldown-",
},
show5: false,
code: null,
pullupConfig: {
content: "",
pullUpHeight: 60,
height: 40,
autoRefresh: false,
downContent: "释放后加载",
upContent: "上拉加载更多",
loadingContent: "加载中...",
clsPrefix: "xs-plugin-pullup-",
},
};
},

beforeMount() {},

mounted() {
const code = this.getQueryString("code");
this.getAccessTokenAndOpenId(code);

},
methods: {
tabbarchange(index) {
this.showMenus = index; 
},
getQueryString(name) {
const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
const r = window.location.search.substr(1).match(reg);
if (r != null) return unescape(r[2]);
return null;
},

getAccessTokenAndOpenId(code) {
if (localStorage.getItem("openId")) {
this.fetchData();
} else {
try {
request(
"get",
`/hitf/v2p/rest/invoke/wenxinAccessToken?code=${code}`
).then((response) => {

if (response.data.openid === null || response.data.openid === undefined) {
alert("获取openId失败为空");
return null;
}
localStorage.setItem("openId", response.data.openid);
this.fetchData();
});
} catch (error) {
console.error("获取openId失败:", error);
alert("获取openId失败：" + error.message);
}
}
},














toDetail(item) {
const openId = localStorage.getItem("openId");
console.log(openId);
if(!item.reservationDocId && (openId === null || openId === undefined)){
return ;
}
this.$router.push({
path: "/reservation/detail",
query: {
reservationDocId: item.reservationDocId,
},
});
},


fetchData() {
request(
"get",
`/hitf/v2p/rest/invoke/mt-reservation-docs?reservationBy=${localStorage.getItem(
"openId"
)}&size=${this.size}`
)
.then((response) => {
this.contentData = response.data.content;
this.$refs.scroller.reset(
{
left: 0,
top: 0,
},
300,
"ease"
);
})
.catch((error) => {
alert("Error fetching data:", error);
});
},


refresh() {
this.fetchData(); 
},

loadMore() {
this.size += 10;
this.pullupConfig.content = "---已经到底了---";
request(
"get",
`/hitf/v2p/rest/invoke/mt-reservation-docs?reservationBy=${localStorage.getItem(
"openId"
)}&size=${this.size}`
)
.then((response) => {
if (this.contentData.length >= response.data.totalElements) {
this.show5 = true;
}
this.contentData = response.data.content;
this.pullupConfig.content = "---已经到底了---";
this.$refs.scroller.donePullup();
})
.catch((error) => {
console.error("Error fetching data:", error);
});



console.log("没有更多数据");
},
},
};



// WEBPACK FOOTER //
// ./src/views/HelloFromVux.vue